(function($) {

  var initializeBlock = function( $block ) {
    $('.loopingVideo video').each(function(index, val) {
      var inview = new Waypoint.Inview({
        element: $(this),
        enter: function(direction) {

        },
        entered: function(direction) {
          var $target = $(this.element[0])
          $target[0].play()
        },
        exit: function(direction) {

        },
        exited: function(direction) {
          var $target = $(this.element[0])
          $target[0].currentTime = 0
        }
      })
    });
  }

  $( document ).ready(function() {
    $('.loopingVideo').each(function() {
      initializeBlock( $(this) );
    })
  })

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=image-video-with-content', initializeBlock );
  }

})( jQuery );
